module.exports = __webpack_public_path__ + "assets/sort-up-white.259759e4.svg";